import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { type AnalysisIntentSource, getAnalysisIntent } from '@/shared/utils/analysis/searchIntent';

/**
 * Redirection automatique vers l'onglet par défaut quand aucun onglet n'est
 * spécifié dans l'URL. L'onglet dépend de l'intention de la recherche :
 * - recherche large (découverte) → niches
 * - recherche ciblée (évaluation), dont zoom et recherche par image →
 *   historique des ventes
 *
 * Tant que l'analyse n'est pas chargée, on ne redirige pas (l'intention est
 * indécidable) — le redirect part dès que la donnée arrive.
 */
export const useAnalysisTabRedirect = (analysisId: string, analysis: AnalysisIntentSource | null | undefined) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!analysisId || !analysis) return;

    const pathSegments = location.pathname.split('/');
    const analysisType = pathSegments[2]; // 'products', 'vendors', ou 'public'

    if (location.pathname === `/analysis/${analysisType}/${analysisId}`) {
      const defaultTab = getAnalysisIntent(analysis) === 'discovery' ? 'niches' : 'history';
      navigate(`/analysis/${analysisType}/${analysisId}/tab/${defaultTab}`, { replace: true });
    }
  }, [location.pathname, analysisId, analysis, navigate]);
};
